import React, { useState, useEffect } from 'react';
import { THEME } from '../../utils/theme';
import api from '../../utils/api';

const BacklogBurndownModal = ({ onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/stats/backlog-history')
      .then(res => setData(res.history || []))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const maxVal = data && data.length > 0 ? Math.max(...data.map(d => d.backlog_total || d.wtp || 1), 1) : 1;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.82)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(24px) saturate(180%)', WebkitBackdropFilter: 'blur(24px) saturate(180%)' }} onClick={onClose}>
      <div style={{ background: THEME.bgCard, borderRadius: '16px', padding: '24px', width: '90%', maxWidth: '600px', maxHeight: '80vh', overflow: 'auto', border: `1px solid ${THEME.border}`, animation: 'scaleIn 0.2s ease' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: THEME.text, fontSize: '20px' }}>Backlog Burndown</h2>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: THEME.textMuted, fontSize: '20px', cursor: 'pointer' }}>×</button>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: THEME.textMuted }}>Loading...</div>
        ) : !data || data.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: THEME.textMuted }}>No data available</div>
        ) : (
          <div>
            <p style={{ color: THEME.textMuted, fontSize: '12px', marginBottom: '20px' }}>Tracking WTP backlog over time</p>
            {/* Simple bar chart using divs */}
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '4px', height: '200px', padding: '10px 0' }}>
              {data.map((d, idx) => (
                <div key={idx} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', height: '180px', justifyContent: 'flex-end' }}>
                    <div style={{ width: '80%', background: THEME.warning, height: `${(d.wtp / maxVal) * 160}px`, borderRadius: '4px' }} title={`WTP: ${d.wtp}`} />
                  </div>
                  {idx % 2 === 0 && <span style={{ color: THEME.textDim, fontSize: '9px', marginTop: '6px' }}>{d.date.slice(5)}</span>}
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', marginTop: '16px' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: THEME.textMuted }}>
                <span style={{ width: '12px', height: '12px', background: THEME.warning, borderRadius: '2px' }} /> WTP (Want to Play)
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BacklogBurndownModal;
